var map = {
	"./de.json": 846,
	"./en.json": 847,
	"./es.json": 848,
	"./fr.json": 849,
	"./it.json": 850,
	"./ja.json": 851,
	"./ko.json": 852,
	"./pt.json": 853,
	"./ru.json": 854,
	"./zh.json": 855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 845;